import { render } from "./InputContactNumber.vue?vue&type=template&id=4a4dc504"
import script from "./InputContactNumber.vue?vue&type=script&lang=js"
export * from "./InputContactNumber.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__